module.exports = __webpack_public_path__ + "img/1519532602.69a91fad.jpg";